<ul>
  <li><button (click)="selectBudget('A')" type="button">A</button></li>
  <li><button (click)="selectBudget('B')" type="button">B</button></li>
  <li><button (click)="selectBudget('C')" type="button">C</button></li>
  <li><button (click)="selectBudget('D')" type="button">D</button></li>
  <li><button (click)="selectBudget('E')" type="button">E</button></li>
</ul>
